<template>
  <div class="page">
    <PageHeader>
      Настройка
    </PageHeader>

    <div class="content">
      <form v-if="info" @submit.prevent="Save()">
        <div class="item">
          <label>Автовывод:</label>
          <el-switch
            v-model="info.autoWithdraw"
            :active-value="true"
            :inactive-value="false"
            active-text="Вкл"
            inactive-text="Выкл"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </div>
        <div class="item">
          <label>Telegram:</label>
          <input
            type="text"
            placeholder="Название"
            v-model="info.socials.tg.title"
          />
          <input
            type="text"
            placeholder="Ссылка"
            v-model="info.socials.tg.href"
          />
        </div>

        <div class="item">
          <label>Jabber:</label>
          <input
            type="text"
            placeholder="Название"
            v-model="info.socials.jabber.title"
          />
          <input
            type="text"
            placeholder="Ссылка"
            v-model="info.socials.jabber.href"
          />
        </div>

        <div class="item">
          <label>Номер телефона:</label>
          <input type="text" placeholder="Номер" v-model="info.phoneNumber" />
        </div>

        <div class="item">
          <label>Процент партнерской программы:</label>
          <input
            type="text"
            placeholder="0.003"
            v-model="info.partnerPercent"
          />
        </div>

        <div class="item">
          <label>Рабочее время:</label>
          <label>От</label>
          <input
            type="text"
            size="5"
            placeholder="От"
            v-model="info.workingTime.from"
          />
          <label>До</label>
          <input
            type="text"
            size="5"
            placeholder="До"
            v-model="info.workingTime.to"
          />
        </div>

        <div class="item">
          <label>Правила обмена</label>
          <textarea
            placeholder="Описание"
            v-model="info.change_rules"
          ></textarea>
        </div>

        <div class="item">
          <label>Партнерская программа</label>
          <textarea
            placeholder="Описание"
            v-model="info.partner_program"
          ></textarea>
        </div>

        <div class="item">
          <label>Программа лояльности</label>
          <textarea
            placeholder="Описание"
            v-model="info.loyalty_program"
          ></textarea>
        </div>

        <div class="item">
          <label>FAQ</label>
          <textarea
            placeholder="Описание"
            v-model="info.partner_program_faq"
          ></textarea>
        </div>

        <div class="item">
          <label>СЕО текст</label>
          <textarea placeholder="Описание" v-model="info.seo_text"></textarea>
        </div>

        <button>Сохранить</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getInfo, updateInfo } from "@/api";
import PageHeader from "../../ui/PageHeader.vue";
//
export default {
  components: { PageHeader },
  name: "Main",

  data: () => ({
    info: false
  }),

  mounted() {
    getInfo().then(response => {
      this.info = response.data.result;
    });
  },

  methods: {
    Save() {
      updateInfo(this.info).then(response => {
        alert("Успешно!");
      });
    }
  }
};
</script>

<style scoped>
.item {
  display: block;
  margin: 5px 0;
}

.item > label,
.item > input {
  display: inline-block;
}

.item > textarea {
  display: block;
  margin-top: 5px;
  padding: 7px;
  font-family: verdana;
  width: 95%;
  min-height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/index.vue